import styled from 'styled-components';

export const Holder = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 100vh;
  width: 100vw;
  max-width: 100%;
  position: relative;
  margin: 0 auto;
  padding: 0;
  z-index: 0;
`;
